var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.41263L8.707 6.70563C8.316 7.09663 7.684 7.09663 7.293 6.70563C6.902 6.31463 6.902 5.68263 7.293 5.29163L11.292 1.29163C11.385 1.19963 11.496 1.12663 11.618 1.07563C11.862 0.974628 12.138 0.974628 12.382 1.07563C12.504 1.12663 12.615 1.19963 12.707 1.29163L16.707 5.29163C17.098 5.68263 17.098 6.31463 16.707 6.70563C16.512 6.90063 16.256 6.99863 16 6.99863C15.744 6.99863 15.488 6.90063 15.293 6.70563L13 4.41263V15.9986C13 16.5516 12.552 16.9986 12 16.9986C11.448 16.9986 11 16.5516 11 15.9986V4.41263ZM20 16.9986C20 16.4456 20.447 15.9986 21 15.9986C21.553 15.9986 22 16.4456 22 16.9986V19.9986C22 21.6526 20.654 22.9986 19 22.9986H5C3.346 22.9986 2 21.6526 2 19.9986V16.9986C2 16.4456 2.448 15.9986 3 15.9986C3.552 15.9986 4 16.4456 4 16.9986V19.9986C4 20.5506 4.449 20.9986 5 20.9986H19C19.552 20.9986 20 20.5506 20 19.9986V16.9986Z",
    fill: "#2F80ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.b211282a.svg";
export { ForwardRef as ReactComponent };